export default "__VITE_ASSET__BsTswkfR__"